<a routerLink="dashboard"><img alt="" src="../../../app/assets/acura/logo-quadrada.svg"></a>